import React, { useState } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

import Sidebar from '../../components/SideBar';
import { AppRoutes, Role, entityArray } from '../../constants/AppConstant';
import UsersPage from '../UserPage';
import CategoriesPage from '../CategoriesPage';
import SubCategoriesPage from '../SubCategoriesPage';
import ComplaintStatusPage from '../ComplaintStatus';
import LocationPage from '../Location';
import ComplaintsPage from '../ComplaintsPage';
import ManagerTechnician from '../ManagerTechnician';
import AssetsPage from '../Assets';
import LocationTypesPage from '../LocationTypes';
import FaqPage from '../FaqPage';
import AdvantagePage from '../AdvantagePage';
import ReviewsPage from '../ReviewsPage';
import HowItWorkPage from '../HowItWorks';
import PhotomitraAdvantage from '../PhotoMitra/AdvantagePage';
import PhotomitraHowItWork from '../PhotoMitra/HowItWorks';
import PhotomitraTakingPhotoSteps from '../PhotoMitra/TakingPhotoSteps';
import PhotomitraPhotoGuidelines from '../PhotoMitra/PhotoGuidelines';
import PhotoSizePage from '../PhotoStore/PhotoSize';
import FileTypePage from '../PhotoStore/FileType';
import ContactInfoPage from '../ContactInfo';
import ParameterFormService from '../ApplicationFormMaster/FormParameters';
import ApplicationFormService from '../ApplicationFormMaster/FormServices';
import ApplicationFormQuestionPage from '../ApplicationFormMaster/FormQuestions';
import PackageServiceAttributesFormService from '../ApplicationFormMaster/FormPackageServiceAttributes';
import FormPackageDocuments from '../ApplicationFormMaster/FormPackageDocuments';
import FormPackageFeatures from '../ApplicationFormMaster/FormPackageFeatures';
import ApplicationFormPackagePlans from '../ApplicationFormMaster/FormPackagePlans';
import ApplicationFormPackagesPage from '../ApplicationFormMaster/FormPackagesPage';
import ServiceProcessStepPage from '../ServicesProcess/ProcessSteps';
import ServiceProcessDetailsPage from '../ServicesProcess/DetailsProcess';
import ProcessSubtitlePage from '../ServicesProcess/ProcessSubtitle';
import ServiceContentManagementPage from '../ServicesProcess/ContentManagement';
import ServiceContentManagementNoParamsPage from '../ServicesProcess/ContentManagementNoParams';
import ServiceContentManagementWithParamsPage from '../ServicesProcess/ContentManagementWithParams';
import FormStepsPage from '../ApplicationFormMaster/FormStepsPage';
import ApplicationFormPage from '../ApplicationFormMaster/ApplicationFormPage';
import ContactFormPage from '../ContactFormPage';
import BecomePartnerInfoPage from '../BecomePartnerInfo';
import PhotoOrderApplicationPage from '../PhotoOrderApplicationPage';
import DocumitraOrderApplicationPage from '../DocumitraOrderApplicationPage';
import DocumitraTransactionPage from '../DocumitraTransactionPage';
import PhotomitraTransactionPage from '../PhotomitraTransactionPage';
import ApplicationFormPages from '../ApplicationFormPages';
import PhotomitraFaqPage from '../PhotomitraFaqPage';
import CouponsManagement from '../CouponsManagement';
import TermsPage from '../TermsPage';
import ConditionsPage from '../ConditionsPage';
import AboutPageOurTeam from '../AboutPageOurTeam';
import ServicePageFAQPage from '../ServicePageFAQ';
import PlansPage from '../PhotoStore/PhotoStorePlansPage';
import HomepageArticlePage from '../HomepageArticle';
import NewsManagementPage from '../NewsManagement';
import RefundRequests from '../RefundRequests';
import PaymentVouchers from '../PaymentVouchers';
import RejectedOrders from '../RejectedOrders';
import PaymentVoucherReport from '../PaymentVouchers/PaymentVoucherReport';
import DocumitraOrderReport from '../Reports/DocumitraOrderReport';

import './styles.scss';
import PackageTimelinePage from '../PackageTimeline/PackageTimelinePage';
import PackageProcessStepPage from '../PackageSteps/PackageProcessStepPage';
import PackageProcessPage from '../PackageProcess/PackageProcessPage';
import PackageContentManagementPage from '../PackageContentManagement';
import ChangePassword from '../ChangePassword';
import SignedUpUsers from '../SignedUpUsers';
import DocumitraLogs from '../DocumitraLogs';
import RefferalDetails from '../RefferalDetails';
import OfferManagement from '../OfferManagement';
import BannerManagement from '../BannerManagement';
import ServiceCardsManagement from '../ServiceCardsManagement';
import HomepageServiceCategories from '../HomepageServiceCategories/index';
import HeaderServicesManagement from '../HeaderServicesManagement';
import BucketManagement from '../BucketManagement';
import PartnerService from '../PartnerService/PartnerService';
import ServiceStepsPage from '../ServicesProcess/ServiceSteps';
import DocumitraPartners from '../DocumitraPartners/DocumitraPartners';
import PartnerServices from '../PartnerServices/PartnerServices';
import PartnerOrders from '../PartnerOrders/PartnerOrders';
import PartnerOrderMembers from '../PartnerOrderMembers/PartnerOrderMembers';
import SeoPage from '../SeoPage';
import B2BAffiliateProgram from '../B2BAffiliateProgram';
import B2BWithdraw from '../B2BWithdraw';
import B2BWithdrawDetail from '../B2BWithdraw/Detail';
import PendingPaymentVerifications from '../PendingPaymentVerifications';
import Dashboard from '../Dashboard';
import Home from '../Home';
import { getRole } from '../../service/CookieManager';

interface LandingRoutesProps {
  hasSpfManagementAccess: boolean;
  currentUserRole?: string | null;
}

const LandingRoutes: React.FC<LandingRoutesProps> = ({
  hasSpfManagementAccess,
  currentUserRole,
}) => (
  <Switch>
    <Route exact path={AppRoutes.Home}>
      <Home />
    </Route>
    <Route exact path={AppRoutes.Dashboard}>
      <Dashboard />
    </Route>
    <Route exact path={`${AppRoutes.Users}`}>
      <UsersPage />
    </Route>
    <Route exact path={`${AppRoutes.SignedUpUsers}`}>
      <SignedUpUsers />
    </Route>
    <Route exact path={`${AppRoutes.Faq}`}>
      <FaqPage />
    </Route>
    <Route exact path={`${AppRoutes.Advantage}`}>
      <AdvantagePage />
    </Route>
    <Route exact path={`${AppRoutes.Reviews}`}>
      <ReviewsPage />
    </Route>
    <Route exact path={`${AppRoutes.HowItWorks}`}>
      <HowItWorkPage />
    </Route>
    <Route exact path={`${AppRoutes.PhotomitraAdvantage}`}>
      <PhotomitraAdvantage />
    </Route>
    <Route exact path={`${AppRoutes.PhotomitraHowItWorks}`}>
      <PhotomitraHowItWork />
    </Route>
    <Route exact path={`${AppRoutes.PhotomitraTakingPhotoStep}`}>
      <PhotomitraTakingPhotoSteps />
    </Route>
    <Route exact path={`${AppRoutes.PhotomitraFaq}`}>
      <PhotomitraFaqPage />
    </Route>
    <Route exact path={`${AppRoutes.PhotomitraPhotoGuidelines}`}>
      <PhotomitraPhotoGuidelines />
    </Route>
    <Route exact path={`${AppRoutes.PhotoStorePhotSize}`}>
      <PhotoSizePage />
    </Route>
    <Route exact path={`${AppRoutes.PhotoStoreFileType}`}>
      <FileTypePage />
    </Route>
    <Route exact path={`${AppRoutes.PhotoStorePlan}`}>
      <PlansPage />
    </Route>
    <Route exact path={`${AppRoutes.ContactInfo}`}>
      <ContactInfoPage />
    </Route>
    <Route exact path={`${AppRoutes.ContactForm}`}>
      <ContactFormPage />
    </Route>
    <Route exact path={`${AppRoutes.BecomePartnerInfo}`}>
      <BecomePartnerInfoPage />
    </Route>
    <Route exact path={`${AppRoutes.ApplicationFormParameters}`}>
      <ParameterFormService />
    </Route>
    <Route exact path={`${AppRoutes.ApplicationFormServices}`}>
      <ApplicationFormService />
    </Route>
    <Route exact path={`${AppRoutes.ApplicationFormQuestion}`}>
      <ApplicationFormQuestionPage />
    </Route>
    <Route exact path={`${AppRoutes.ApplicationFormPackageServiceAttributes}`}>
      <PackageServiceAttributesFormService />
    </Route>
    <Route exact path={`${AppRoutes.ApplicationFormPackageDocuments}`}>
      <FormPackageDocuments />
    </Route>
    <Route exact path={`${AppRoutes.ApplicationFormPackageFeatures}`}>
      <FormPackageFeatures />
    </Route>
    <Route exact path={`${AppRoutes.ApplicationFormPackagePlans}`}>
      <ApplicationFormPackagePlans />
    </Route>
    <Route exact path={`${AppRoutes.ApplicationFormPackages}`}>
      <ApplicationFormPackagesPage />
    </Route>
    <Route exact path={`${AppRoutes.ServiceProcessSteps}`}>
      <ServiceProcessStepPage />
    </Route>
    <Route exact path={`${AppRoutes.ServiceProcessDetailsProcess}`}>
      <ServiceProcessDetailsPage />
    </Route>
    <Route exact path={`${AppRoutes.ServiceProcessSubtitle}`}>
      <ProcessSubtitlePage />
    </Route>
    <Route exact path={`${AppRoutes.ServiceTimeline}`}>
      <Redirect
        to={hasSpfManagementAccess ? AppRoutes.ContactServiceContentManagement : AppRoutes.Users}
      />
    </Route>
    <Route exact path={`${AppRoutes.PackageTimeline}`}>
      <PackageTimelinePage />
    </Route>
    <Route exact path={`${AppRoutes.ServiceProcessFaqManagement}`}>
      {hasSpfManagementAccess ? (
        <ServiceContentManagementPage />
      ) : (
        <Redirect to={AppRoutes.Users} />
      )}
    </Route>
    <Route exact path={`${AppRoutes.ServiceContentManagementNoParams}`}>
      {hasSpfManagementAccess ? (
        <ServiceContentManagementNoParamsPage />
      ) : (
        <Redirect to={AppRoutes.Users} />
      )}
    </Route>
    <Route exact path={`${AppRoutes.ServiceContentManagementWithParams}`}>
      {hasSpfManagementAccess ? (
        <ServiceContentManagementWithParamsPage />
      ) : (
        <Redirect to={AppRoutes.Users} />
      )}
    </Route>
    <Route exact path={`${AppRoutes.ContactServiceContentManagement}`}>
      {hasSpfManagementAccess ? (
        <ServiceContentManagementPage />
      ) : (
        <Redirect to={AppRoutes.Users} />
      )}
    </Route>
    <Route exact path={`${AppRoutes.PackageProcess}`}>
      <PackageProcessPage />
    </Route>
    <Route exact path={`${AppRoutes.PackageProcessSteps}`}>
      <PackageProcessStepPage />
    </Route>
    <Route exact path={`${AppRoutes.PackageProcessFaqManagement}`}>
      {hasSpfManagementAccess ? (
        <PackageContentManagementPage />
      ) : (
        <Redirect to={AppRoutes.Users} />
      )}
    </Route>
    <Route exact path={`${AppRoutes.ContactPackageContentManagement}`}>
      {hasSpfManagementAccess ? (
        <PackageContentManagementPage />
      ) : (
        <Redirect to={AppRoutes.Users} />
      )}
    </Route>
    <Route exact path={`${AppRoutes.ApplicationFormSteps}`}>
      <FormStepsPage />
    </Route>
    <Route exact path={`${AppRoutes.ApplicationForm}`}>
      <ApplicationFormPage />
    </Route>
    <Route exact path={`${AppRoutes.CouponsManagement}`}>
      <CouponsManagement />
    </Route>
    <Route exact path={`${AppRoutes.OfferManagement}`}>
      <OfferManagement />
    </Route>
    <Route exact path={`${AppRoutes.BannerManagement}`}>
      <BannerManagement />
    </Route>
    <Route exact path={`${AppRoutes.ServiceCardsManagement}`}>
      <ServiceCardsManagement />
    </Route>
    <Route exact path={`${AppRoutes.HomepageServiceCategory}`}>
      <HomepageServiceCategories />
    </Route>
    <Route exact path={`${AppRoutes.HeaderServices}`}>
      <HeaderServicesManagement />
    </Route>
    <Route exact path={`${AppRoutes.PartnerService}`}>
      <PartnerService />
    </Route>
    <Route exact path={`${AppRoutes.BucketManagement}`}>
      <BucketManagement />
    </Route>
    <Route exact path={`${AppRoutes.TermsConditionTerms}`}>
      <TermsPage />
    </Route>
    <Route exact path={`${AppRoutes.TermsConditionConditions}`}>
      <ConditionsPage />
    </Route>
    <Route exact path={`${AppRoutes.AboutPageOurTeam}`}>
      <AboutPageOurTeam />
    </Route>
    <Route exact path={`${AppRoutes.ServicePageFAQ}`}>
      <ServicePageFAQPage />
    </Route>
    <Route exact path={`${AppRoutes.RelatedArticle}`}>
      <Redirect
        to={hasSpfManagementAccess ? AppRoutes.ContactServiceContentManagement : AppRoutes.Users}
      />
    </Route>
    <Route exact path={`${AppRoutes.HomepageArticle}`}>
      <HomepageArticlePage />
    </Route>
    <Route exact path={`${AppRoutes.NewsManagement}`}>
      <NewsManagementPage />
    </Route>
    <Route exact path={`${AppRoutes.DocumitraLogs}`}>
      <DocumitraLogs />
    </Route>
    <Route exact path={`${AppRoutes.RefferalDetails}`}>
      <RefferalDetails />
    </Route>
    <Route exact path={`${AppRoutes.Categories}`}>
      <CategoriesPage />
    </Route>
    <Route exact path={`${AppRoutes.Subcategories}`}>
      <SubCategoriesPage />
    </Route>
    <Route exact path={`${AppRoutes.complainStatus}`}>
      <ComplaintStatusPage />
    </Route>
    <Route exact path={`${AppRoutes.locationType}`}>
      <LocationTypesPage />
    </Route>
    <Route exact path={`${AppRoutes.locations}`}>
      <LocationPage />
    </Route>
    <Route exact path={`${AppRoutes.complaintsPage}`}>
      <ComplaintsPage />
    </Route>
    <Route exact path={`${AppRoutes.managerTechnician}`}>
      <ManagerTechnician />
    </Route>
    <Route exact path={`${AppRoutes.assets}`}>
      <AssetsPage />
    </Route>
    <Route exact path={AppRoutes.PhotoOrderApplication}>
      <ApplicationFormPages />
    </Route>
    <Route path={`${AppRoutes.PhotoOrderApplication}/:id`}>
      <ApplicationFormPages />
    </Route>
    <Route exact path={AppRoutes.DocumitraOrderApplication}>
      <DocumitraOrderApplicationPage />
    </Route>
    <Route exact path={AppRoutes.DocumitraOrderTransaction}>
      <DocumitraTransactionPage />
    </Route>
    <Route exact path={AppRoutes.PhotoOrderTransaction}>
      <PhotomitraTransactionPage />
    </Route>
    <Route path={`${AppRoutes.DocumitraOrderApplication}/:id`}>
      <DocumitraOrderApplicationPage />
    </Route>
    <Route path={`${AppRoutes.Stores}/:id/store-variant-price`}>
      <PhotoOrderApplicationPage />
    </Route>
    <Route path={`${AppRoutes.Stores}/:id/store-add-ons`}>
      <PhotoOrderApplicationPage />
    </Route>
    <Route path={`${AppRoutes.Stores}/:id/store-bulk-add-ons`}>
      <PhotoOrderApplicationPage />
    </Route>
    <Route path={`${AppRoutes.Stores}/:id/slots`}>
      <PhotoOrderApplicationPage />
    </Route>
    <Route path={`${AppRoutes.ChangePassword}`}>
      <ChangePassword />
    </Route>
    <Route exact path={AppRoutes.RefundRequests}>
      <RefundRequests />
    </Route>
    <Route exact path={AppRoutes.PaymentVouchers}>
      <PaymentVouchers />
    </Route>
    <Route exact path={AppRoutes.RejectedOrders}>
      {currentUserRole === Role.SUPER_ADMIN ||
      currentUserRole === Role.ACCOUNTANT ||
      currentUserRole === Role.ADMIN_OPS ? (
        <RejectedOrders />
      ) : (
        <Redirect to={AppRoutes.Home} />
      )}
    </Route>
    <Route exact path={AppRoutes.PaymentVoucherReport}>
      <PaymentVoucherReport />
    </Route>
    <Route exact path={AppRoutes.DocumitraOrderReport}>
      {/* Accountant: Refund Request + Payment Voucher reports only (filtered in the page). */}
      {currentUserRole === Role.SUPER_ADMIN || currentUserRole === Role.ACCOUNTANT ? (
        <DocumitraOrderReport />
      ) : (
        <Redirect to={AppRoutes.Home} />
      )}
    </Route>
    <Route exact path="/service-steps">
      <ServiceStepsPage />
    </Route>
    <Route exact path={AppRoutes.DocumitraPartners}>
      <DocumitraPartners />
    </Route>
    <Route exact path={AppRoutes.PartnerServices}>
      <PartnerServices />
    </Route>
    <Route exact path={`${AppRoutes.PartnerOrders}`}>
      <PartnerOrders />
    </Route>
    <Route exact path={`${AppRoutes.AgentPaymentLedger}`}>
      <Redirect to={AppRoutes.DocumitraPartners} />
    </Route>
    <Route exact path={`${AppRoutes.PendingPaymentVerifications}`}>
      <PendingPaymentVerifications />
    </Route>
    <Route exact path="/pending-payment-verifications">
      <Redirect to={AppRoutes.PendingPaymentVerifications} />
    </Route>
    <Route exact path={`${AppRoutes.PartnerOrderMembers}`}>
      <PartnerOrderMembers />
    </Route>
    <Route exact path={AppRoutes.B2BAffiliateProgram}>
      <B2BAffiliateProgram />
    </Route>
    <Route exact path={AppRoutes.B2BWithdraw}>
      <B2BWithdraw />
    </Route>
    <Route path={AppRoutes.B2BWithdrawDetail}>
      <B2BWithdrawDetail />
    </Route>
    <Route exact path={AppRoutes.Seo}>
      <SeoPage />
    </Route>
    {/*
      Unknown path inside the app shell. App used to redirect anything it did
      not recognise to Home before Landing ever rendered; now that Landing
      owns every path, it needs its own fallback so a bad URL lands on Home
      rather than an empty content area.
    */}
    <Route path="*">
      <Redirect to={AppRoutes.Home} />
    </Route>
  </Switch>
);

const Landing: React.FC = () => {
  const [moduleList] = useState<any>(entityArray);
  const currentUserRole = getRole();
  const hasSpfManagementAccess =
    currentUserRole === Role.SUPER_ADMIN || currentUserRole === Role.CONTENT_MANAGER;

  return (
    <Router>
      <div className="landing-box">
        <Sidebar title="Documitra" entityArr={moduleList} />
        <div className="landing-box-content">
          <div className="landing-box-scroll">
            <LandingRoutes
              hasSpfManagementAccess={hasSpfManagementAccess}
              currentUserRole={currentUserRole}
            />
          </div>
        </div>
      </div>
    </Router>
  );
};

export default Landing;
